import { rem } from 'polished';
import styled from 'styled-components';

import { IUserType } from '../../';
import { IStyledWrapperProps } from './TextInput.types';

export const CountryCodeDropDownWrapper = styled.div`
  position: absolute;
  left: 0;
  bottom: ${rem('21px')};
`;

export const StyledInput = styled.input<IUserType>`
  padding: 0;
  padding-bottom: ${({ theme }) => rem(theme.spacings.xs)};
  color: ${({ theme }) => theme.colors.cross.black};
  font-size: ${({ theme }) => rem(theme.spacings.s)};
  line-height: 1.4;
  background-color: transparent;
  border: none;
  border-bottom: 1px solid
    ${({ disabled, theme }) =>
      disabled ? 'transparent' : theme.colors.cross.silverFox};
  transition: all 0.5s ease;
  appearance: none;

  &:focus {
    border-bottom-color: ${({ theme, user }) =>
      user && theme.colors[user].main};
    outline: none;
  }

  &:-webkit-autofill::first-line,
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    font-size: ${({ theme }) => rem(theme.spacings.s)};
  }
`;

export const StyledLabel = styled.label`
  position: absolute;
  top: ${rem('30px')};
  left: 0;
  color: ${({ theme }) => theme.colors.cross.grayson};
  font-size: ${({ theme }) => rem(theme.spacings.s)};
  line-height: 1.4;
  pointer-events: none;
`;

export const StyledSwitch = styled.button`
  position: absolute;
  right: 0;
  bottom: ${rem('26px')};
  width: ${({ theme }) => rem(theme.spacings.m)};
  height: ${({ theme }) => rem(theme.spacings.m)};
  padding: 0;
  line-height: ${({ theme }) => rem(theme.spacings.m)};
  background: transparent;
  border: none;
  cursor: pointer;
  appearance: none;

  svg {
    display: block;
    width: 100%;
    height: auto;
  }
`;

export const StyledWrapper = styled.div<IStyledWrapperProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  padding-top: ${rem('29px')};
  padding-bottom: ${rem('20px')};

  ${({ inputValue }) =>
    !!inputValue &&
    `
    ${StyledLabel} {
      top: 0;
    }
  `}

  ${({ isActive }) =>
    isActive &&
    `
    ${StyledLabel} {
      top: 0;
    }
  `}

  ${({ hasCountryCodeDropDown }) =>
    hasCountryCodeDropDown &&
    `
    ${StyledInput} {
      padding-left: ${rem('60px')};
    }
  `}

${({ hasCountryCodeDropDown, isActive }) =>
    hasCountryCodeDropDown &&
    !isActive &&
    `
    ${StyledLabel} {
      padding-left: ${rem('60px')};
    }
  `}
`;
